module.exports = __webpack_public_path__ + "img/list_8_zh.1091b392.png";